import $ from "jquery";
import vuwer from "@pressmedia/vuwer";

vuwer.add("appHeader", {
	selector: "#app_header",
	
	onReady($self) {
		if(!$self) {
			return false;
		}
		
		const position = $self.css("position");
		if("absolute_fixed".indexOf(position) >= 0) {
			vuwer.get("body").smoothScrollBuffer += $self.outerHeight(true);
		}
	}
}, function() {
	// add child Vuw
	this
	// [title]
	.add("title", {
		selector: "#app_title",
		onReady($self) {
			if( $self && $self.is(":empty") ) {
				return this.setState("txt", document.title);
			}
		},
		onChangeState(state) {
			if(this.$self && state.txt) {
				this.$self.empty().append( $("<span/>").text(state.txt) );
			}
		}
	});
});
